import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import * as R from 'ramda'
import UploadAvatar from 'app/components/widgets/UploadAvatar'
import { megaBytesToBytes, fileToBase64, alertSizeOverLimit } from 'libs/file'

// size in bytes
const PHOTO_SIZE_LIMIT = megaBytesToBytes(10)

const ProfileAvatar = ({ avatar, onAvatarSelect, alt }) => {
  const [isPhotoUploading, setIsPhotoUploading] = useState(false)

  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const handleUploadAvatar = R.ifElse(
    R.propSatisfies(R.lt(R.__, PHOTO_SIZE_LIMIT), 'size'),
    (file) => {
      setIsPhotoUploading(false)
      fileToBase64(file).then((fileData) => onAvatarSelect(fileData))
    },
    () => {
      alertSizeOverLimit(dispatch, formatMessage, PHOTO_SIZE_LIMIT)
    },
  )

  return (
    <UploadAvatar
      name={alt}
      onChange={handleUploadAvatar}
      src={avatar}
      isLoading={isPhotoUploading}
    />
  )
}

export default ProfileAvatar
